import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
/* eslint-disable react-hooks/exhaustive-deps */
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useMissingItems } from "../apis";

const useMissingItemsList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    orderBy: sorting[0]?.id,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
  };

  const {
    missingItemsList,
    meta,
    isLoading,
    refetch: refetchMissingItems
  } = useMissingItems(requestParams);

  return {
    missingItemsList,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchMissingItems
  };
};

export default useMissingItemsList;
